import EventsAPI from "../../../shared/modules/EventsAPI";
import React from "react";

const TextMessages = () => (
  <div className="text-messages">
    <p className="styled_h5 center">
        Don&#39;t miss out
    </p>
    <div className="center">
        Get text message updates about your shipment!
    </div>
    <a
      className="btn btn-secondary centered mt32 mb32"
      href="/account/communication_preferences"
      id="get-text-messages"
      onClick={() => EventsAPI.trackCustomerEvent("clicked_cta_lihp", "Get Text Messages")} // eslint-disable-line react/jsx-no-bind,max-len
    >
        Get Text Messages
    </a>
  </div>
);

export default TextMessages;
